import React from 'react';
import classes from './Footer.module.scss';

const Footer = () => {

  const List = ({ header, items, className }) => (
    <ul className={classes.List}>
      { header ?
        <li className={[classes.Item, classes.Header].join(' ')}>{header}</li> : null
      }
      {
        items.map((item, i) => {
          if (item.href)
            return (
              <li key={i} className={classes.Item}>
                <a href={item.href} className={classes.Link}>{item.value}</a>
              </li>
            )
          else
              return <li key={i} className={classes.Item}>{item.value}</li>
        })
      }
    </ul>
  );

  return (
    <footer className={classes.Footer}>
      <div className={classes.Top}>
        <div className={classes.Left}>
          <List header="Head Office" items={[
            { value: '37 Highway Road' },
            { value: 'Dhaka, 1219' },
            { value: 'Bangladesh' }
          ]} />

          <List header="Contact Details" items={[
            { value: 'azher@gmail.com', href: '#' },
            { value: 'azheruddin.com', href: '#' },
            { value: '+(880) 1300 00133', href: '#' }
          ]} />
        </div>
        <div className={classes.Right}>
          <List items={[
            { value: 'Privacy Policy', href: '#' },
            { value: 'Cookie Policy', href: '#' },
            { value: 'Sitemap', href: '#' }
          ]} />
        </div>
      </div>
      <div className={classes.Bottom}>
        <p className={classes.Text}>&copy; 2020 Azher. All Right reserved</p>
        <p className={classes.Text}>Created by <a href="https://www.facebook.com/azher.uddin.617" target='_blank' rel="noopener noreferrer" className={classes.Link}>Azher Uddin</a></p>
      </div>
    </footer>
  );
}

export default Footer;
